"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapPositionUtils = require("../util/mapPositionUtils");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/PropertyMarkers/PropertyPill.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

// TODO: Figure out how to combine this with PropertyDot's more opinionated heart svg
var heart = _react.default.createElement("div", {
  style: {
    display: 'inline-block',
    marginRight: '2px'
  },
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9
  },
  __self: void 0
}, _react.default.createElement("svg", {
  className: "quick-styling",
  style: {
    width: "15px",
    height: "15px"
  },
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  width: "25px",
  height: "25px",
  viewBox: "0 0 25 25",
  enableBackground: "new 0 0 25 25",
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10
  },
  __self: void 0
}, _react.default.createElement("path", {
  fill: "white",
  d: "M18.7,2.5 c-2.6,0-5.1,1.5-6.2,3.6 C11.4,4,8.9,2.5,6.3,2.5 C2.8,2.5,0,5.3,0,8.8 c0,1.7,0.7,3.3,1.9,4.5l9.6,9.1 c0.3,0.3,0.7,0.4,1,0.4 c0.4,0,0.7-0.1,1-0.4l9.7-9.2 c0,0,0,0,0.1-0.1 C24.4,12,25,10.4,25,8.8 C25,5.3,22.2,2.5,18.7,2.5 z",
  __source: {
    fileName: _jsxFileName,
    lineNumber: 25
  },
  __self: void 0
})));

var splitLabel = function splitLabel(label) {
  if (label && label.indexOf('\t')) {
    return label.split('\t');
  }

  return [];
}; // This class is a copy of PropertyLabel. It currently only supports ZO property markers and 
//     does not support multiple labels. It doesn't have a size cache because it is not nested
//     under a PropertyDot and therefore gets autocentered.


var PropertyPill =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(PropertyPill, _PureComponent);

  function PropertyPill() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = PropertyPill.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        markerLabel = _this$props.markerLabel,
        labelClassNames = _this$props.labelClassNames,
        favorite = _this$props.favorite,
        visited = _this$props.visited;
    var labels = splitLabel(markerLabel);

    if (labels.length < 1) {
      return null;
    }

    var forwardProps = (0, _mapPositionUtils.getForwardableProperties)(this.props);
    forwardProps.className = "property-pill " + labelClassNames + " " + forwardProps.className + " " + (visited ? 'visited' : '');
    return _react.default.createElement("div", _extends({}, forwardProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70
      },
      __self: this
    }), _react.default.createElement("div", {
      className: "pill-floating-label",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71
      },
      __self: this
    }, "ZILLOW"), favorite && heart, _react.default.createElement("div", {
      style: {
        display: 'inline-block',
        overflow: 'hidden'
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75
      },
      __self: this
    }, markerLabel));
  };

  return PropertyPill;
}(_react.PureComponent);

PropertyPill.propTypes = process.env.NODE_ENV !== "production" ? {
  markerLabel: _propTypes.default.string,
  labelClassNames: _propTypes.default.string,
  favorite: _propTypes.default.bool,
  visited: _propTypes.default.bool
} : {};
PropertyPill.defaultProps = {
  markerLabel: '',
  labelClassNames: '',
  favorite: false,
  visited: false
};
/* eslint-enable no-underscore-dangle */

var _default = PropertyPill;
exports.default = _default;